import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCN_1X46jv2MS9bTdxRDzozHLkmJRUGxAc",
  authDomain: "suitcase-muse.firebaseapp.com",
  projectId: "suitcase-muse",
  storageBucket: "suitcase-muse.firebasestorage.app",
  messagingSenderId: "105134094813",
  appId: "1:105134094813:web:68c3bed0a20e728206de34",
  measurementId: "G-MXW6F0HE2W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Analytics only where the browser supports it. getAnalytics() can
// throw during module evaluation (e.g. when IndexedDB is blocked or in some
// privacy modes); because this module is imported almost everywhere, an eager
// throw here would white-screen the entire app instead of degrading gracefully.
export let analytics: Analytics | null = null;
isSupported()
  .then((supported) => {
    if (supported) analytics = getAnalytics(app);
  })
  .catch(() => {
    /* Analytics unavailable in this environment; ignore. */
  });

export const functions = getFunctions(app);

export default app;
